<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control" 
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                            class="mr-2"
                                            right
                                            v-b-tooltip.hover
                                            :title="$t('label.filter')"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.status') }}
                                                </label>
                                                <multiselect
                                                    v-model="isActive"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="statusDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                        <b-button
                                            variant="info"
                                            v-on:click="openForm"
                                            v-b-tooltip.hover
                                            :title="$t('label.createX', [])"
                                        >
                                            <i class="mdi mdi-plus"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(status)="data">
                                    <b-badge
                                        :variant="tableRows[data.index].isActive ? 'success' : 'secondary'"
                                    >
                                        {{ tableRows[data.index].isActive ? $t('label.active') : $t('label.inactive') }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="data.item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive==0?'restore':'outline'}`]"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="country-form"
            :title="$t(country.uuid ? 'label.updateX' : 'label.createX', [$t('module.country')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
        >
            <b-container fluid>
                <CountryForm
                    :countryUUID="country.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="countryForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="country-delete"
            :title="country.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ country.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('country-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ country.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { countryMethods } from "@/state/api";
import { COUNTRY_MODULE } from "@/state/api/country.state";
import CountryForm from "@/views/pages/admin/country/countryForm";

export default {
    components: { Multiselect, CountryForm },
    created() {
        sessionHelper.clearSearch(SESSION.COUNTRY_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            fields: [
                { key: 'name', label: i18n.t("label.name"), sortable: true, class: 'text-nowrap' },
                { key: 'code', label: i18n.t("label.code"), sortable: true, class: 'text-nowrap' },
                { key: 'status', label: i18n.t("label.status"), sortable: false, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            country: {
                uuid: "",
                isActive: false,
            },
        };
    },
    methods: {
        ...countryMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.COUNTRY_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.COUNTRY_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getCountryList(this.searchCriteria);
        },
        getCountryList(filter) {
            this.getAllCountry({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.COUNTRY_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.COUNTRY_SEARCH);
            filter.pageNumber = pageNumber;
            this.getCountryList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getCountryList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.country = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('country-delete');
        },
        requestDelete() {
			let data = {
                uuid: this.country.uuid,
				isActive: this.country.isActive == 0 ? 1 : 0,
			};
            this.updateCountryStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('country-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.country = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('country-form');
            });
        },
        closeForm() {
            this.country = {
                uuid: "",
                isActive: false,
            };
            this.$bvModal.hide('country-form');
        },
    },
	computed: {
		...mapState(COUNTRY_MODULE, ['status']),
		tableRows() {
			return this.$store.state.api.country.list.data || [];
		},
		totalPage() {
			return this.$store.state.api.country.list.pagination.total || 0;
		},
	},
}
</script>